import api from '../../api/axios';
import styles from "../dash_styles/order.module.css"
import { useEffect, useState } from "react";

import CurrencyDisplay from "../dash_component/CurrencyDisplay";
import getDate from './getDate';
import ViewOrder from './ViewOrder';

const Order = () => {
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderItems, setOrderItems] = useState({ items : [] });

    const fetchOrder = async () => {
        try {
            const res = await api.get('/order');
            setOrders(res.data.orders)
        } catch (error) {
            console.error('Error fetching orders', error);
        }
    };


    const status = (status) => {
        if (status === 'Pending') {
            return styles.pending
        }

        if (status === 'Processing') {
            return styles.processing
        }

        if (status === 'Canceled') {
            return styles.canceled
        }

        if (status === 'Completed') {
            return styles.completed
        }
    }

    useEffect(() => {
        fetchOrder();
    }, []);

    const completedOrders = orders.filter(order => order.status.toLowerCase() === 'completed');
    const canceledOrders = orders.filter(order => order.status.toLowerCase() === 'canceled');
    const pendingOrders = orders.filter(order => order.status.toLowerCase() === 'pending');
    const processingOrders = orders.filter(order => order.status.toLowerCase() === 'processing');

    return (
        <div className={styles.mainContainer}>
           {selectedOrder && (
                <ViewOrder 
                    order={selectedOrder} 
                    orderItems={orderItems} 
                    className={styles.view}
                    setSelectedOrder={setSelectedOrder}
                />
            )} 
            <div className={styles.header}>
                <div className={styles.statCard}>
                    <div className={styles.stat}>
                        <p>{orders.length}</p>
                    </div>
                    <div className={styles.statInfo}>
                        <p className={styles.topText}>Total Orders</p>
                    </div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.stat} style={{ backgroundColor: 'rgba(176, 89, 219, 0.54)'}}>
                        <p>{pendingOrders.length}</p>
                    </div>
                    <div className={styles.statInfo}>
                        <p className={styles.topText}>Total Orders</p>
                        <p style={{ color: 'grey'}}>Pending</p>
                    </div>
                </div>
                 <div className={styles.statCard}>
                    <div className={styles.stat} style={{ backgroundColor: 'rgba(219, 213, 89, 0.54)'}}>
                        <p>{processingOrders.length}</p>
                    </div>
                    <div className={styles.statInfo}>
                        <p className={styles.topText}>Total Orders</p>
                        <p style={{ color: 'grey'}}>Processing</p>
                    </div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.stat} style={{ backgroundColor: 'rgba(213, 13, 20, 0.54)'}}>
                        <p>{canceledOrders.length}</p>
                    </div>
                    <div className={styles.statInfo}>
                        <p className={styles.topText}>Total Orders</p>
                        <p style={{ color: 'grey'}}>Canceled</p>
                    </div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.stat} style={{ backgroundColor: 'rgba(64, 160, 61, 0.54)'}}>
                        <p>{completedOrders.length}</p>
                    </div>
                    <div className={styles.statInfo}>
                        <p className={styles.topText}>Total Orders</p>
                        <p style={{ color: 'grey'}}>Completed</p>
                    </div>
                </div>
            </div>
            <div className={styles.feedback}>
                <div className={styles.mainTableContainer}>
                    <div className={styles.outerTable}>
                        <form >
                            <table>
                                <thead>
                                    <tr>
                                        <th className={styles.col1}>po#</th>
                                        <th className={styles.col2}>status</th>
                                        <th className={styles.col3}>order date</th>
                                        <th className={styles.col3}>payment method</th>
                                        <th className={styles.col5}>order total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(orders) && orders.map(order => (
                                        <tr key={order.id} onClick={() => {setSelectedOrder(order); setOrderItems(order.items); }} style={{ cursor: 'pointer' }}>
                                            <td><p>FED-02340{order.id}</p></td>
                                            <td><p>{order.status}</p></td>
                                            <td><p>{getDate(order.created_at)}</p></td>
                                            <td><p>{order.payment_method}</p></td>
                                            <td><CurrencyDisplay amount={order.total} currency='CAD'/></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Order;